export default __webpack_public_path__ + "static/media/EPB_BLACK.original.893ab84e.png";